import { AccordionExpandibles } from "components/accordion";
import "../sections.css";

import { Col, Container, Row } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCards } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-cards";
import { useEffect, useState } from "react";
import feature_1 from "assets/images/home_carousel/feature_1.png";
import feature_2 from "assets/images/home_carousel/feature_2.png";
import feature_3 from "assets/images/home_carousel/feature_3.png";

function Products() {
  const [accordionState, setAccordionState] = useState();
  const [swiper, setSwiper] = useState();

  useEffect(() => {
    if (swiper) swiper.slideTo(accordionState);
  }, [accordionState, swiper]);

  return (
    <section className="section products">
      <div className="container">
        <div className="py-5">
          <Container fluid>
            <Row>
              <Col md="7">
                <AccordionExpandibles setAccordionState={setAccordionState} />
              </Col>
              <Col
                md="5"
                className="d-flex flex-row align-items-center d-none d-lg-flex"
              >
                <>
                  <Swiper
                    effect={"cards"}
                    grabCursor={true}
                    modules={[EffectCards]}
                    className="mySwiper"
                    onSwiper={(swiper) => setSwiper(swiper)}
                  >
                    <SwiperSlide>
                      <img src={feature_1} alt="arrow-right" />
                    </SwiperSlide>
                    <SwiperSlide>
                      <img src={feature_2} alt="arrow-right" />
                    </SwiperSlide>
                    <SwiperSlide>
                      <img src={feature_3} alt="arrow-right" />
                    </SwiperSlide>
                    <SwiperSlide>
                      <img src={feature_1} alt="arrow-right" />
                    </SwiperSlide>
                    <SwiperSlide>
                      <img src={feature_3} alt="arrow-right" />
                    </SwiperSlide>
                  </Swiper>
                </>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </section>
  );
}

export default Products;
